import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgSharesPerReelConfig = {
    name: 'kpi.instagram.avg_shares_per_reel',
    id: 'average_shares_per_reel',
    icon: {
        name: 'share',
        style: colors.aquablue
    },
    tooltip: 'kpi.instagram.tooltip_avg_shares_per_reel',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    orientation: ORIENTATION_VERTICAL,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    type: 'kpi',
    element: KPIDefault,
    noDataToken: 'analytics:kpi.instagram.no_posts_period',
    loader: DefaultLoader
};
